var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l((_vm.itemsWithImg),function(article,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","xl":"3"}},[_c('StoresCard',{attrs:{"item":_vm.itemsWithImg[index]}})],1)}),_c('v-col',{attrs:{"cols":"12"}},[_c('stores-link')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }